window.HelloRetailSearchAPI = (() => {
  const ENDPOINT = 'https://core.helloretail.com/serve/search';
  let abortController = null;

  async function search(key, phrase, options = {}) {
    if (abortController) abortController.abort();
    abortController = new AbortController();

    const trackingUserId = await window.HelloRetailService?.getTrackingUserId().catch(() => null);

    const payload = {
      query: phrase,
      key,
      ...(trackingUserId && { trackingUserId }),
      products: {
        start: options.productStart ?? 0,
        count: options.productCount ?? 7,
        fields: [
          'title', 'url', 'imgUrl', 'price', 'oldPrice', 'brand', 'currency', 'inStock',
          'extraData.id', 'productNumber', 'trackingCode', 'description',
          'extraData.pimcontentAmount', 'extraData.pimcontentUnit', 'extraData.pimshortDescription',
          'extraData.pimbrandDanishO', 'extraData.pimbrandEUOrganic',
          'extraData.pricechangejobactive', 'extraData.fastlavpris', 'extraData.isNew',
          'extraDataList.allImages',
        ],
        returnFilters: options.returnFilters ?? false,
        ...(options.filters?.length && { filters: options.filters }),
        ...(options.sorting && { sorting: options.sorting }),
      },
      categories: {
        start: 0,
        count: options.categoryCount ?? 5,
        fields: ['title', 'url'],
      },
      brands: {
        start: 0,
        count: options.brandCount ?? 5,
        fields: ['title', 'url'],
      },
      sitePages: {
        start: 0,
        count: options.articleCount ?? 3,
        fields: ['title', 'url', 'description'],
      },
    };

    const res = await fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: abortController.signal,
    });

    if (!res.ok) {
      const body = await res.text().catch(() => '');
      console.error('HR search error response:', body);
      throw new Error(`HR search: ${res.status}`);
    }
    return res.json();
  }

  async function popular(count = 12) {
    const trackingUserId = await window.HelloRetailService?.getTrackingUserId().catch(() => null);
    const websiteUuid = window.HelloRetailService?.websiteUuid;

    const fields = ['title', 'url', 'imgUrl', 'price', 'oldPrice', 'brand', 'currency', 'inStock', 'extraData', 'trackingCode'];

    // If we have a trackingUserId, Hello Retail knows this visitor —
    // use the managed product box for personalised recommendations.
    // Otherwise fall back to generic TOP products.
    const request = trackingUserId
      ? { key: 'k6a01aa4a372a61be0d2e8b58', format: 'json', fields }
      : { trackingKey: 'search-popular', count, fields, sources: [{ type: 'TOP' }] };

    const payload = {
      websiteUuid,
      ...(trackingUserId && { trackingUserId }),
      requests: [request],
    };

    const res = await fetch('https://core.helloretail.com/serve/recoms', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    if (!res.ok) throw new Error(`HR popular: ${res.status}`);
    const data = await res.json();
    return data.responses?.[0]?.products ?? [];
  }

  return { search, popular };
})();
